import { Link, Outlet } from "react-router-dom"

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-muted/30">
      <header className="border-b bg-background">
        <div className="mx-auto flex h-14 max-w-6xl items-center px-6">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            Hirefy
          </Link>
        </div>
      </header>
      <main className="mx-auto flex max-w-md flex-col gap-6 px-6 py-12">
        <Outlet />
      </main>
    </div>
  )
}
